module.exports = __webpack_public_path__ + "static/media/perla_ramos_rata.558d5def.png";